export const getRecomFetch = async (userIdPartyHash) => {
  let recomResponse = null;
  const module = await import("@gerenciatd/next13.adabyron.abs-layer.get-credit");
  const getCredit = module.default;
  try {
    recomResponse = await getCredit(userIdPartyHash);
  } catch (e) {
    console.error(e);
  } finally {
    return recomResponse;
  }
};

const isMoreThan24Hours = (tsUserRecom) => {
  let res = true;
  if (tsUserRecom) {
    const tsNow = Date.now();
    const msDay = 1000 * 60 * 60 * 24;

    const diferenciaEnMilisegundos = tsUserRecom !== -1 ? tsNow - tsUserRecom : msDay;
    const diferenciaEnHoras = diferenciaEnMilisegundos / (1000 * 60 * 60);
    res = diferenciaEnHoras >= 24;
  }
  return res;
};

const getRecom = async ({ persistedInfo, ad_storage, analytics_storage, setUserRecom }) => {
    // 1) Solo si ha aceptado las cookies guardamos las recomendaciones del usuario
    //          Sino, lo guardamos como nulo ya que, o no ha aceptado cookies o no esta logado
    let userRecom = null;
    const isCookieGranted = ad_storage === "granted" && analytics_storage === "granted";

    if (isCookieGranted && persistedInfo.userIdPartyHash) {
      userRecom = persistedInfo.userRecom;
      const moreThan24Hours = isMoreThan24Hours(persistedInfo.tsUserRecom);

      // 2) Llamamos al api si han pasado 24h o no tengo userRecom
      if (moreThan24Hours) {
        let recomResponse = null;
        try {
          recomResponse = await getRecomFetch(persistedInfo.userIdPartyHash);
          if (recomResponse && recomResponse.userRecom) {
            userRecom = recomResponse.userRecom;
            import("@gerenciatd/next13.utils.secure.local-storage").then((module) => {
              let secureStorage = module.default;
              secureStorage = new secureStorage();
              const persistedInfo = secureStorage.getItem("ts");
              secureStorage.setItem("ts", {...persistedInfo, userRecom});
            });
          }
        } catch (e) {
          console.log(e);
        } 
      }
    }
    setUserRecom({ userRecom });
};

export default getRecom;
